import React, { Fragment, useEffect } from 'react';
import InputFieldText from '../../../../../components/input/floating-label/input-field/InputFieldText';
import Select from '../../../../../components/select/Select';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../../redux/store';

import { connect } from 'react-redux';
import { AnlieferkennzeichenModel } from '../../../../../models/AnlieferkennzeichenModel';
import {
  setAbsenderreferenz,
  setAbwBeladung,
  setAnlieferkennzeichen,
  setAuftragField,
  setBeladedatum,
  setBeladezeitBis,
  setBeladezeitVon,
  setEntladedatum,
  setIsAbwBeladeAdresseSet,
} from '../../../../../redux/actions/auftragserfassung';
import { toSelectOptions } from '../../../../../components/select/SelectModel';
import { nameof } from '../../../../../utils/objectUtils';
import SliderCheckbox from '../../../../../components/slidercheckbox/SliderCheckbox';
import { ConfigModel } from '../../../../../models/ConfigModel';
import { Auftrag } from '../../../../../api';
import {
  isoDateToDate,
  nextWorkingDayFromDate,
} from '../../../../../utils/date';

interface VersenderProps {
  auftragserfassung: StateModel_Auftragserfassung;
  setBeladedatum: (value: string | undefined) => void;
  setBeladezeitVon: (value: string | undefined) => void;
  setBeladezeitBis: (value: string | undefined) => void;
  setAbsenderreferenz: (value: string | undefined) => void;
  setAnlieferkennzeichen: (value: number | undefined) => void;
  anlieferkennzeichen: AnlieferkennzeichenModel[];
  isDisableUhrzeitfelder?: boolean;
  setAuftragField: (value: any, fieldname: string) => void;
  setAbwBeladung: (value: boolean | undefined) => void;
  isAbwBeladung?: boolean;
  setIsAbwBeladeAdresseSet: (value: boolean | undefined) => void;
  isAbwBeladeAdresseSet?: boolean;
  isNeutralerAbsenderSet?: boolean;
  neutralerAbsenderAdresse?: number;
  setEntladedatum: (value: string | undefined) => void;
  config: ConfigModel;
}

const VersenderWrapper = (props: VersenderProps) => {
  const setAbwBeladung = (value: boolean) => {
    setAuftragField(value, 'abweichendeBeladung');
    props.setAbwBeladung(value);
  };
  const isBEXITY = props.config?.clientKunde?.toUpperCase() == 'BEXITY';
  const zustelldatumOffset = props.config.zustelldatum_offset;

  const getAwbBeladungSliderVisible = () => {
    if (isBEXITY) return false;
    else return props.isAbwBeladeAdresseSet; //return true;
  };

  const getAwbBeladungSliderDisabled = () => {
    if (props.isNeutralerAbsenderSet) return true;
    if (!props.isAbwBeladeAdresseSet) return true;
    return false;
  };

  const className_absenderreferenz_empfaengerreferenz =
    getAwbBeladungSliderVisible() == true
      ? 'absenderreferenz-empfaengerreferenz_60_percent'
      : 'absenderreferenz-empfaengerreferenz_full';

  const onChangeAbholung = (value: string) => {
    props.setBeladedatum(value);
    if (
      props.config.isEntladedatumVorbelegen &&
      (props.auftragserfassung.status === undefined ||
        props.auftragserfassung.status.id == 1) //<---dann neuer Auftrag oder noch nicht übertragen
    ) {
      props.setEntladedatum(
        isoDateToDate(nextWorkingDayFromDate(value, zustelldatumOffset))
      );
    }
  };

  useEffect(() => {
    isoDateToDate(
      nextWorkingDayFromDate(
        isoDateToDate(props.auftragserfassung.beladedatum),
        zustelldatumOffset
      )
    );
  }, []);

  return (
    <Fragment>
      <div className={'wrapper-adresse-bottom'}>
        <div className={'referenz-abw'}>
          <InputFieldText
            name={nameof<Auftrag>('absenderReferenz')}
            maxlength={isBEXITY ? 35 : 20}
            tooltip={isBEXITY ? 'max. 35 Zeichen' : 'max. 20 Zeichen'}
            label='Absenderreferenz'
            classes={className_absenderreferenz_empfaengerreferenz}
            onChangeHandler={props.setAbsenderreferenz}
            value={props.auftragserfassung.absenderreferenz}
          />

          {getAwbBeladungSliderVisible() && (
            <div id='abwBeladung'>
              <span className={'switch-label'}>abw. Labeldruck:</span>
              &nbsp;
              <SliderCheckbox
                classes='abwBeladung'
                value={props.isAbwBeladung} //#84769 wenn neutraler Absender gesetzt ist, auf NEIN stellen.
                onChangeHandler={setAbwBeladung}
                labelActive={'Ja'}
                labelInactive={'Nein'}
                disabled={getAwbBeladungSliderDisabled()}
                tooltip={
                  'Soll die abweichende Abholadresse auf dem Label angedruckt werden?'
                }
              />
            </div>
          )}
        </div>
        <div className={'adress-datum'}>
          <InputFieldText
            name={'abholung'}
            label='Abholung'
            classes='datum'
            inputType='date'
            onChangeHandler={onChangeAbholung}
            value={props.auftragserfassung.beladedatum}
          />
          {!props.isDisableUhrzeitfelder && (
            <div className={'von-bis'}>
              <InputFieldText
                label='von'
                classes='von'
                inputType='time'
                onChangeHandler={props.setBeladezeitVon}
                value={props.auftragserfassung.beladezeitVon?.toString() ?? ''}
              />
              <InputFieldText
                name={'abholzeitvonkleinerbis'}
                label='bis'
                classes='bis'
                inputType='time'
                onChangeHandler={props.setBeladezeitBis}
                value={props.auftragserfassung.beladezeitBis?.toString() ?? ''}
              />
            </div>
          )}

          <Select
            className='anlieferkennzeichen'
            headerTitle='Anlieferart'
            onChangeHandler={props.setAnlieferkennzeichen}
            selectedOptionId={
              props.auftragserfassung.anlieferkennzeichen ?? undefined
            }
            selectData={toSelectOptions(
              props.anlieferkennzeichen,
              nameof<AnlieferkennzeichenModel>('langBezeichnung'),
              true,
              true
            )}
          />
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state: StateModel) => ({
  anlieferkennzeichen: state.Stammdaten.anlieferkennzeichen,
  auftragserfassung: state.Auftragserfassung,
  isDisableUhrzeitfelder: state.Config.isDisableUhrzeitfelder,
  isAbwBeladung: state.Auftragserfassung.abweichendeBeladung,
  neutralerAbsenderAdresse: state.Auftragserfassung.neutralerAbsenderAdresse,
  isAbwBeladeAdresseSet: state.Auftragserfassung.isAbweichendeBeladeAdresse,
  isNeutralerAbsenderSet: state.Auftragserfassung.isNeutralerAbsenderAdresse,
  config: state.Config,
});

export default connect(mapStateToProps, {
  setBeladedatum,
  setBeladezeitVon,
  setBeladezeitBis,
  setAbsenderreferenz,
  setAnlieferkennzeichen,
  setAuftragField,
  setAbwBeladung,
  setIsAbwBeladeAdresseSet,
  setEntladedatum,
})(VersenderWrapper);
